<template>
  <div class="boost-active-values">
    <div class="boost-active-values__wrapper">
      <div
        v-for="(choice, index) of choices"
        :key="`${choice}-${index}`"
        class="boost-active-values__tags"
      >
        <boost-active-value-tag
          v-if="!choice.includes('page')"
          :id="choice"
          :choice="choice"
          :image="getSwatchImage(choice)"
          :sort-by-options="sortByOptions"
          :tabindex="0"
          @click="choicesUpdated"
        />
      </div>
    </div>

    <btn
      class="boost-active-values__clear-all"
      :label="$string('collection.clear_all')"
      @click="$emit('clear-choices')"
    />
  </div>
</template>

<script>

/**
 * Vue: Boost active values (boost-active-values)
 * -----------------------------------------------------------------------------
 * Selected filter values and 'clear all' button for Boost filters.
 *
 * @param {Array} choices - Available choices.
 * @param {Object} sortByOptions - Options for sorting.
 *
 */
import BoostActiveValueTag from '~async/main-collection/boost-active-value-tag'
import Btn from '~global/btn/btn'

import { convertToHandle } from '~/helpers/convert'

export default {
  name: 'BoostActiveValues',

  components: {
    BoostActiveValueTag,
    Btn,
  },

  props: {
    choices: {
      type: Array,
      default: () => [],
    },
    sortByOptions: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: {
    'choices-updated': (payload) => typeof payload === 'object',
    'clear-choices': () => true,
  },

  methods: {

    /**
     * Receive user input from tags and pass up to filter component.
     * @param {Object} event - Click event.
     */
    choicesUpdated(event) {
      const data = {
        requestParam: `&${event.currentTarget.id}`,
        action: 'remove',
      }

      this.$emit('choices-updated', data)
    },

    /**
     * Get swatch image based on color choice.
     * @param {String} choice - Formatted URL param for choice.
     */
    getSwatchImage(choice) {
      if (
        !cnvs.filterSwatches ||
        !cnvs.urls ||
        !choice.includes('pf_opt_color')
      ) {
        return null
      }

      const valueKey = decodeURI(choice.split('=')[1])
      const handle = convertToHandle(valueKey)
      const found = cnvs.filterSwatches.find((swatch) => swatch.key === handle)

      if (!found) {
        return null
      }

      const url = cnvs.urls.files.replace('placeholder', found.swatch)

      return `url(${url})`
    },
  },
}
</script>

<style lang="scss">
@import './boost-active-values';
</style>
